
import { TrekPackage } from '@/lib/types/trek-types';

/**
 * Map database schema to TrekPackage frontend model
 */
export function mapDbSchemaToPackage(dbPackage: any): TrekPackage {
  return {
    id: dbPackage.id,
    trekId: dbPackage.trek_id,
    companyId: dbPackage.company_id,
    name: dbPackage.name,
    description: dbPackage.description,
    price: dbPackage.price,
    duration: dbPackage.duration,
    maxGroupSize: dbPackage.max_group_size,
    startDates: dbPackage.start_dates,
    includedMeals: dbPackage.included_meals,
    transport: dbPackage.transport,
    equipmentIncluded: dbPackage.equipment_included,
    experiencedGuides: dbPackage.experienced_guides,
    accommodationType: dbPackage.accommodation_type,
    cancellationPolicy: dbPackage.cancellation_policy,
    highlightFeatures: dbPackage.highlight_features,
    booking_link: dbPackage.booking_link,
    is_active: dbPackage.is_active
  };
}

/**
 * Map TrekPackage frontend model to database schema
 */
export function mapPackageToDbSchema(trekPackage: Partial<TrekPackage>) {
  return {
    id: trekPackage.id,
    trek_id: trekPackage.trekId,
    company_id: trekPackage.companyId,
    name: trekPackage.name,
    description: trekPackage.description,
    price: trekPackage.price,
    duration: trekPackage.duration,
    max_group_size: trekPackage.maxGroupSize,
    start_dates: trekPackage.startDates,
    included_meals: trekPackage.includedMeals,
    transport: trekPackage.transport,
    equipment_included: trekPackage.equipmentIncluded,
    experienced_guides: trekPackage.experiencedGuides,
    accommodation_type: trekPackage.accommodationType,
    cancellation_policy: trekPackage.cancellationPolicy,
    highlight_features: trekPackage.highlightFeatures,
    booking_link: trekPackage.booking_link,
    is_active: trekPackage.is_active
  };
}
